export const currencyPaths = {
  exchangeRateToday: '/api/currencies/exchange-rate/today',
} as const;
